import React, { useState, useEffect } from "react";
import { Plus, Edit, Trash, View } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

const Content = () => {
  const navigate = useNavigate();
  const [Contents, setContents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedContentId, setSelectedContentId] = useState(null);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 20;
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchContent();
    } else {
      navigate("/");
    }
  }, [navigate, offset]);

  const fetchContent = async () => {
    try {
      const response = await apiService.postData("admin/content-list", {
        limit,
        offset,
      });
      if (response?.data?.rows) {
        setContents(response.data.rows);
        setTotalCount(response.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching Contents:", error);
    }
  };

  const handleEdit = (contentId) => navigate(`/edit-content/${contentId}`);
  const handleView = (contentId) => navigate(`/view-content/${contentId}`);

  const openModal = (contentId) => {
    setSelectedContentId(contentId);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (selectedContentId) {
      try {
        await apiService.deleteData(`admin/content/${selectedContentId}`);
        setContents((prev) =>
          prev.filter((c) => c.content_id !== selectedContentId)
        );
        setIsModalOpen(false);
      } catch (error) {
        console.error("Error deleting content:", error);
      }
    }
  };
  const handleCheckboxChange = (contentId) => {
    setSelectedIds((prev) =>
      prev.includes(contentId)
        ? prev.filter((id) => id !== contentId)
        : [...prev, contentId]
    );
  };
  const handleBulkDelete = async () => {
    try {
      await apiService.postData("admin/delete-multiple-content", {
        content_id: selectedIds,
      });
      setContents((prev) =>
        prev.filter((c) => !selectedIds.includes(c.content_id))
      );
      setSelectedIds([]);
    } catch (error) {
      console.error("Error deleting selected content:", error);
    }
  };
    
  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;
  const renderPagination = () => {
    const pageNumbers = [];
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, currentPage + halfRange);

    if (startPage > 1) pageNumbers.push(1);
    if (startPage > 2) pageNumbers.push("...");

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (endPage < totalPages - 1) pageNumbers.push("...");
    if (endPage < totalPages) pageNumbers.push(totalPages);

    return pageNumbers.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setOffset((page - 1) * limit)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="btn mx-1 disabled">
          {page}
        </span>
      )
    );
  };
  return (
    <div className="container">
      <div className="card">
      
        <div className="card-header d-flex justify-content-between align-items-center">
  <h4>Content</h4>
  <div>
    {selectedIds.length > 0 && (
      <button onClick={handleBulkDelete} className="btn btn-danger me-2">
        Delete Selected <Trash size={16} />
      </button>
    )}
    <button
      onClick={() => navigate("/new-content")}
      className="btn btn-primary"
    >
      New Content <Plus size={16} />
    </button>
  </div>
</div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                <th>
      <input
        type="checkbox"
        onChange={(e) =>
          setSelectedIds(
            e.target.checked ? Contents.map((c) => c.content_id) : []
          )
        }
        checked={Contents.length > 0 && selectedIds.length === Contents.length}
      />
    </th>
                  <th>Title</th>
                  <th style={{ width: '200px' }}>Description</th>
                  <th>Duration(In Seconds)</th>
                  <th>Chapter Count</th>
                  <th>Tags</th>
                  <th>RFID</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Contents.map((content) => (
                  <tr key={content.content_id}>
                     <td>
    <input
      type="checkbox"
      checked={selectedIds.includes(content.content_id)}
      onChange={() => handleCheckboxChange(content.content_id)}
    />
  </td>
                    <td>{content.title || "-"}</td>
                    <td>{content.description || "-"}</td>
                    <td>{content.duration || "-"}</td>
                    <td>{content.chapter_count || "-"}</td>
                    <td>{content.tags || "-"}</td>
                    <td>{content.rfid || "-"}</td>
                    {/* <td>
                      <button onClick={() => handleEdit(content.content_id)} className="btn btn-primary btn-sm">
                        <Edit size={16} />
                      </button>
                      <button onClick={() => openModal(content.content_id)} className="btn btn-danger btn-sm ms-2">
                        <Trash size={16} />
                      </button>
                    </td> */}
                    <td>
  <div className="dropdown">
    <button
      className="btn btn-outline-primary btn-sm dropdown-toggle"
      type="button"
      id={`dropdownMenuButton${content.content_id}`}
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Action
    </button>
    <ul
      className="dropdown-menu"
      aria-labelledby={`dropdownMenuButton${content.content_id}`}
    >
      <li>
        <button
          className="dropdown-item"
          onClick={() => handleEdit(content.content_id)}
        >
          <Edit size={14} className="me-2" />
          Edit
        </button>
      </li>
      <li>
        <button
          className="dropdown-item"
          onClick={() => handleView(content.content_id)}
        >
          <View size={14} className="me-2" />
          View
        </button>
      </li>
      <li>
        <button
          className="dropdown-item text-danger"
          onClick={() => openModal(content.content_id)}
        >
          <Trash size={14} className="me-2" />
          Delete
        </button>
      </li>
    </ul>
  </div>
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <nav className="d-flex justify-content-center my-3">
          <button className="btn btn-outline-primary me-2" onClick={() => setOffset(offset - limit)} disabled={offset === 0}>
            «
          </button>
          {renderPagination()}
          <button className="btn btn-outline-primary ms-2" onClick={() => setOffset(offset + limit)} disabled={offset + limit >= totalCount}>
            »
          </button>
        </nav>
      </div>

      {isModalOpen && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this content?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleDelete}>Yes</button>
                <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>No</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Content;
